export enum DateSelectionMode {
  Date = "date",
  Period = "period",
}

export enum OverviewPeriod {
  OneDay = "1_day",
  SevenDays = "7_days",
  ThirtyDays = "30_days",
}

export interface DateFilterByDate {
  type: DateSelectionMode.Date;
  dateTs: number;
}

export interface DateFilterByPeriod {
  type: DateSelectionMode.Period;
  period: OverviewPeriod;
  startTs: number;
}

export type DateFilter = DateFilterByDate | DateFilterByPeriod;

export interface DatePeriodSelectorProps {
  period: OverviewPeriod;
  selectedDate: Date;
  mode: DateSelectionMode;
  /**
   * Controls whether the "period" (1/7/30 days) quick options are available.
   * If disabled, the component acts as a single-date selector only.
   */
  isPeriodEnabled?: boolean;
  onChange?: (filter: DateFilter) => void;
  className?: string;
}

export interface PeriodOption {
  period: OverviewPeriod;
  days: number;
}
